import React, { useState, useEffect, memo, PropsWithChildren } from "react";
import * as BiIcons from "react-icons/bi";
import * as AiIcons from "react-icons/ai";
import { useSelector } from "react-redux";
interface steps extends PropsWithChildren {
  check?: boolean;
  title1?: string;
  title2?: string;
  title3?: string;
}
function Header({ check, title1, title2, title3 }: steps) {
  const [shotbar, setshotbar] = useState(true);

  const account = useSelector((state: any) => state.auth);

  let autoResize = () => {
    if (window.innerWidth < 991) {
      setshotbar(false);
    } else {
      setshotbar(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", autoResize);
    autoResize();
  }, []);
  return (
    <React.Fragment>
      {check ? (
        <>
         <span className="d-flex align-items-center">
            <span className="d-flex align-items-center">
              <span className="f-28 fw-700">{title1}</span> &nbsp;
              {/* <span>
                <AiIcons.AiFillCaretRight />
              </span> */}
            </span>
            &nbsp;
            {title2 && (
              <>
                <span className="d-flex align-items-center">
                  <span className="f-28 fw-700">{title2}</span>&nbsp;
                  <AiIcons.AiFillCaretRight />
                </span>
              </>
            )}
            &nbsp;
            {title3 && (
              <>
               <span className="d-flex align-items-center">
                <span className="f-28 fw-700">{title3}</span>&nbsp;
                <AiIcons.AiFillCaretRight />
                </span>
              </>
            )}
          </span>
        </>
      ) : (
        <>
          <li className="me-4">
            {shotbar ? (
              <div className="welcome ">Welcome back {account.email}</div>
            ) : (
              <>
                <span className="welcomes">Welcome back </span>
                <br></br>
                <span className="name">{account.email}</span>
              </>
            )}
          </li>
          {/* <li>
            <div className="ui icon input search-bar">
              <input placeholder="Search" type="text" />

              <i
                aria-hidden="true"
                className="search circular inverted link icon"
              >
                <BiIcons.BiSearchAlt2 />
              </i>
            </div>
          </li> */}
        </>
      )}
    </React.Fragment>
  );
}

export default memo(Header);
